import { EligibilityVerdict } from "eligibility/models";

export interface VerdictDisplay {
  label: string;
  // Ant Design status color keyword.
  color: "success" | "error" | "warning";
}

// Maps a verdict to its banner label + color. See technical-design.md §F.
export const verdictDisplay = (verdict: EligibilityVerdict): VerdictDisplay => {
  switch (verdict) {
    case "pass":
      return { label: "QUALIFIES for Direct Install", color: "success" };
    case "fail":
      return { label: "Does not qualify", color: "error" };
    default:
      return { label: "Needs more data", color: "warning" };
  }
};

export const KW_LIMIT = 300;
export const THERM_LIMIT = 40_000;
